import "./reset.css";

import { css, type SerializedStyles } from "@emotion/react";
import { useCallback } from "react";

import { useScreenDetector } from "../screen-type";
import {
  border,
  borderBlockEnd,
  borderBlockStart,
  borderInlineEnd,
  borderInlineStart,
} from "./border";
import { linearGradient, rgba, setOpacity } from "./colors";
import { gridColumn, gridRow } from "./grid";
import { inset } from "./position";
import { boxShadow } from "./shadow";
import {
  margin,
  marginBlock,
  marginInline,
  padding,
  paddingBlock,
  paddingInline,
} from "./spacing";
import { typo } from "./typo";

export type CSSProp = Parameters<typeof css>[0] | Parameters<typeof css>[1];

export const cssFns = {
  center: () =>
    css({
      display: "grid",
      placeItems: "center",
    }),
  margin,
  marginBlock,
  marginInline,
  padding,
  paddingBlock,
  paddingInline,
  typo,
  rgba,
  setOpacity,
  linearGradient,
  border,
  borderBlockEnd,
  borderBlockStart,
  borderInlineEnd,
  borderInlineStart,
  gridColumn,
  gridRow,
  inset,
  boxShadow,
};

export const createStaticStyles = (styles: {
  common?: CSSProp;
  desktop?: CSSProp;
  mobile?: CSSProp;
}) => {
  return {
    common: css(styles.common),
    desktop: styles.desktop ? css(styles.desktop) : undefined,
    mobile: styles.mobile ? css(styles.mobile) : undefined,
  };
};

export const useStaticStyles = () => {
  const { isMobile } = useScreenDetector();
  return {
    staticStyles: useCallback(
      (styles: {
        common?: SerializedStyles;
        desktop?: SerializedStyles;
        mobile?: SerializedStyles;
      }) => [styles.common, isMobile ? styles.mobile : styles.desktop],
      [isMobile],
    ),
  };
};
